import { render } from "./AdminResultTable.vue?vue&type=template&id=35a573a0&scoped=true"
import script from "./AdminResultTable.vue?vue&type=script&lang=js"
export * from "./AdminResultTable.vue?vue&type=script&lang=js"

import "./AdminResultTable.vue?vue&type=style&index=0&id=35a573a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a573a0"]])

export default __exports__